// extracted by mini-css-extract-plugin
module.exports = {"size":"counter_size_30UCW","btnsize":"counter_btnsize_3DYuN","numbersize":"counter_numbersize_2YIgG","buy":"counter_buy_zINDs"};